const splitTime = (time: number) => {
  const days = Math.floor(time / (24 * 60 * 60 * 1000));
  const hours = Math.floor((time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((time % (60 * 1000)) / 1000);
  return [days, hours, minutes, seconds]
}

// 倒计时 传入剩余时间(戳) 返回倒计时时间
export default function useTimeCountDown(timeStamp: number, onFinish?: () => void, autoStart = true) {
  const days = ref(0)
  const hours = ref(0)
  const minutes = ref(0)
  const seconds = ref(0)
  const isFinished = ref(false)
  
  let tid
  const start = () => {
    stop();

    if (timeStamp > 0) {
      tid = setInterval(() => {
        timeStamp -= 1000;
      
        ;[days.value, hours.value, minutes.value, seconds.value] = splitTime(timeStamp)

        if (timeStamp <= 0) {
          isFinished.value = true
          clearInterval(tid)
          onFinish?.()
        }
      }, 1000);
    } else {
      isFinished.value = true
      onFinish?.()
    }
  }

  const stop = () => {
    clearInterval(tid)
  }
  
  const changeTime = (time: number) => {
    timeStamp = time
    start()
  }

  onUnmounted(() => {
    stop()
  })
  
  if (autoStart) start()

  return {
    days,
    hours,
    minutes,
    seconds,
    isFinished,
    changeTime,
    start,
    stop
  }
}
